import { createSelector } from '@ngrx/store';
import { TimeSlotsState } from '../reducers/timeslots.reducer';
import { selectTimeSlotsState, selectTenantState } from '../reducers';
import { TenantState } from '../reducers/tenant.reducers';

export const getTimeSlotsTableState = createSelector(
  selectTimeSlotsState,
  (state: TimeSlotsState) => { return { total: state.total, currentPage: state.currentPage, perPage: state.perPage, order: state.order, direction: state.direction, filters: state.filters, includes: state.includes } }
);

export const getTimeSlots = createSelector(
  selectTimeSlotsState,
  (state: TimeSlotsState) => state.list
);

export const getTotalTimeSlots = createSelector(
  getTimeSlotsTableState,
  (tableState) => tableState.total
);

export const getTimeSlotsCurrentPage = createSelector(
  getTimeSlotsTableState,
  (tableState) => tableState.currentPage
);

export const getTimeSlotsPerPage = createSelector(
  getTimeSlotsTableState,
  (tableState) => tableState.perPage
);

export const getTimeSlotsDirection = createSelector(
  getTimeSlotsTableState,
    (tableState) => tableState.direction
);

export const getFilters = createSelector(
  getTimeSlotsTableState,
  (tableState) => tableState.filters
);

export const getTimeSlotDialogId = createSelector(
  selectTimeSlotsState,
  (state: TimeSlotsState) => state.dialogId
);

export const getSelectionDialogId = createSelector(
  selectTimeSlotsState,
  (state: TimeSlotsState) => state.selectionDialogId
);

// Selettore per ottenere selectedTenantId da TimeSlotsState
export const selectSelectedTenantId = createSelector(
  selectTimeSlotsState,
  (state: TimeSlotsState) => {
    //console.log('selectedTenantId:', state.selectedTenantId); 
    return state.selectedTenantId
  }
);

export const selectTenantName = createSelector(
  selectTenantState,  // Stato dei tenant
  selectSelectedTenantId,  // selectedTenantId da TimeSlotsState
  (tenantState: TenantState, selectedTenantId: number) => {
    //console.log('TenantState:', tenantState);
    const tenant = tenantState.list.find(t => t.id === selectedTenantId);
    return tenant ? tenant.name : null;
  }
);



// Sviluppo futuro per selezionare tenant dinamicamente

// export const getSelectedTenant = createSelector(
//     selectTimeSlotsState,
//   (state: TenantState) => {
//     console.log("🔹 Stato completo nel selettore:", state);
//     console.log("🔹 selectedTenants nel selettore:", state.selectedTenants);
//     return state.selectedTenants.length > 0 ? state.selectedTenants[0] : null 
//   }
// );




// export const getSelectedTenants = createSelector(
//    selectTimeSlotsState,
//   (state: TimeSlotsState) => state.list

// );

export const getSelectedTimeSlotsCurrentPage = createSelector(
selectTimeSlotsState,
  (state: TimeSlotsState) => {
    const selectedHours = (state.selectedTimeSlots || []).map(bl => bl.id);
    return state.list?.filter(bl => selectedHours.includes(bl.id));
  }
);